import React from 'react';
import { mergeStyleSets, mergeStyles } from '@fluentui/react';
import ErrorMessageComponent from '../error-message/error-message.component';

import ItemOrdenDeTrabajo from '../../models/ItemOrdenDeTrabajo';

import lockIcon from '../../assets/img32/cerrado_32.png';
import playIcon from '../../assets/img32/play_32.png';
import flagIcon from '../../assets/img32/finalizado_32.png';
import pauseIcon from '../../assets/img32/pause_32.png';
import signatureIcon from '../../assets/img32/firma_32.png';
import attachedIcon from '../../assets/img32/adjunto_32.png';

const getStatusColor = (wo: ItemOrdenDeTrabajo): string => {
    if (wo.Cerrado || wo.Estado === 40) return '#e53935'; // rojo - cerrada
    if (wo.Estado === 10) return '#4CAF50';               // verde - pendiente
    if (wo.Estado === 20) return '#2196F3';               // azul - en curso
    if (wo.Estado === 30) return '#FF9800';               // naranja - finalizada
    return '#9E9E9E';                                      // gris - default
};

const listClasses = mergeStyleSets({
    card: {
        backgroundColor: '#ffffff',
        borderRadius: 10,
        marginBottom: 8,
        boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
        overflow: 'hidden',
        cursor: 'pointer',
        transition: 'box-shadow 0.15s',
        display: 'flex',
        selectors: {
            ':hover': {
                boxShadow: '0 3px 14px rgba(0,0,0,0.14)',
                backgroundColor: '#fff8f7',
            },
        },
    },
    sidebar: {
        width: 6,
        flexShrink: 0,
        borderRadius: '10px 0 0 10px',
    },
    cardInner: {
        flex: 1,
        minWidth: 0,
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        gap: 8,
        borderBottom: '1px solid #f0f0f0',
    },
    docNumber: {
        fontWeight: 700,
        fontSize: 13,
        color: 'var(--color-primario)',
        flexShrink: 0,
    },
    customerName: {
        fontSize: 12,
        color: '#555',
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    date: {
        fontSize: 11,
        color: '#aaa',
        flexShrink: 0,
    },
    cardBody: {
        padding: '6px 12px 10px',
    },
    asunto: {
        fontSize: 12,
        fontWeight: 600,
        color: '#333',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        marginBottom: 2,
    },
    description: {
        fontSize: 12,
        color: '#444',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        lineHeight: '1.4',
    },
    icons: {
        display: 'flex',
        gap: 6,
        marginTop: 6,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
});

interface IWorkOrderListComponentProps {
    onSelectWorkOrder: (value: ItemOrdenDeTrabajo) => void;
    workOrders: ItemOrdenDeTrabajo[];
};

const WorkOrderListComponent = (props: IWorkOrderListComponentProps) => {
    return (
        <>
            {(props.workOrders.length === 0) ? (
                <ErrorMessageComponent message='No hay datos para mostrar' />
            ) : (
                props.workOrders.map((wo: ItemOrdenDeTrabajo) => {
                    const firstTask = wo.ListaTareas?.[0];
                    return (
                        <div
                            key={wo.Id.toString()}
                            className={listClasses.card}
                            onClick={() => props.onSelectWorkOrder(wo)}>
                            <div
                                className={mergeStyles(listClasses.sidebar, { backgroundColor: getStatusColor(wo) })} />
                            <div className={listClasses.cardInner}>
                                <div className={listClasses.cardHeader}>
                                    <span className={listClasses.docNumber}>{wo.NumeroDocumento}</span>
                                    <span className={listClasses.customerName}>{wo.Nombre}</span>
                                    <span className={listClasses.date}>{wo.FechaOrden}</span>
                                </div>
                                <div className={listClasses.cardBody}>
                                    {(firstTask?.Nombre || wo.Asunto) && (
                                        <div className={listClasses.asunto}>{firstTask?.Nombre || wo.Asunto}</div>
                                    )}
                                    {(firstTask?.Descripcion || wo.Descripcion) && (
                                        <div className={listClasses.description}>{firstTask?.Descripcion || wo.Descripcion}</div>
                                    )}
                                    <div className={listClasses.icons}>
                                        {wo.Firmas ? (
                                            <img src={signatureIcon} alt="Firma" height={18} width={18} />
                                        ) : null}
                                        {wo.Adjuntos ? (
                                            <img src={attachedIcon} alt="Adjunto" height={18} width={18} />
                                        ) : null}
                                        {wo.Cerrado ? (
                                            <img src={lockIcon} alt="Cerrado" height={18} width={18} />
                                        ) : wo.IconoEstado === "C" ? (
                                            <img src={playIcon} alt="En curso" height={18} width={18} />
                                        ) : wo.IconoEstado === "F" ? (
                                            <img src={flagIcon} alt="Finalizado" height={18} width={18} />
                                        ) : wo.IconoEstado === "P" ? (
                                            <img src={pauseIcon} alt="Pausado" height={18} width={18} />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })
            )}
        </>
    );
};

export default WorkOrderListComponent;

